import { trackEvent } from './analytics';

// Helper functions for common tracking events

export const trackContactFormSubmit = (formType = 'contact') => {
  trackEvent('Contact Form Submit', {
    form_type: formType,
    page: window.location.pathname
  });
};

export const trackPhoneClick = () => {
  trackEvent('Phone Number Click', {
    page: window.location.pathname
  });
};

export const trackEmailClick = () => {
  trackEvent('Email Click', {
    page: window.location.pathname
  });
};

export const trackServiceClick = (serviceName) => {
  trackEvent('Service Click', {
    service_name: serviceName,
    page: window.location.pathname
  });
};

export const trackProjectView = (projectName) => {
  trackEvent('Project View', {
    project_name: projectName,
    page: window.location.pathname
  });
};

export const trackCareerPageView = () => {
  trackEvent('Career Page View', {
    page: window.location.pathname
  });
};

export const trackDownload = (fileName, fileType) => {
  trackEvent('File Download', {
    file_name: fileName,
    file_type: fileType,
    page: window.location.pathname
  });
};

export const trackExternalLinkClick = (url, linkText) => {
  trackEvent('External Link Click', {
    url: url,
    link_text: linkText,
    page: window.location.pathname
  });
};